import * as React from 'react'

export const SvgChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} aria-hidden={true} {...props}>
    <path d="M15 16.137L13.61 17.5 8 12l5.61-5.5L15 7.863 10.78 12z" />
  </svg>
)
export default SvgChevronLeft
